// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { useEffect } from "react";

export const useHandleShouldLoadCart = () => {
    const dispatch = useAppDispatch();
    const shouldLoadCart = useShouldLoadCart();

    useEffect(() => {
        if (shouldLoadCart) {
            dispatch(loadCurrentCart({ shouldLoadFullCart: false, replaceCart: false }));
        }
    }, [shouldLoadCart]);
};

export const useShouldLoadCart = () => {
    return useAppSelector(state => !getCurrentCartState(state).value && !getCurrentCartState(state).isLoading);
};
